import { createStyles } from '@mantine/core';

export const useStyles = createStyles( theme => ( {
	renderingText: {
		...theme.other.fonts.bodyRegular,
		color: theme.other.palette.white,
		textAlign: 'center',
	},
	doNotCloseText: {
		...theme.other.fonts.mediumButton,
		color: theme.other.palette.white,
		marginTop: 16,
	},
} ) );
